<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div class="card_container" style="border-radius: 17px">
          <div class="card_block mt-1">
            <div class="card_item">
              <h3 class="card__header purple_text">
                {{ $t("text.manageExpenses.totalExpenses") }}
              </h3>
            </div>
            <div class="card_item mt-3">
              <div class="card_icon_div dealer__icon__div">
                <img src="@/assets/img/Page-1 (3).svg" width="35px" />
              </div>
            </div>
            <div class="card_item mt-3">
              <h3 class="card__header purple_text">{{ expensesCount }}</h3>
            </div>
          </div>
        </div>
        <div
          class="mr-3 background__layout pump__bg"
          style="border-radius: 12px; flex: 0 0 75%"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-5"
              style="display: flex; justify-content: space-between"
            >
              <h4 class="text-center text-white">
                {{ $t("text.manageExpenses.title") }}
              </h4>
            </div>
            <div
              class="col-md-4"
              style="display: flex; justify-content: center"
            >
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#4b2d73"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>
      </div>
      <section class="pump__details__section_2">
        <div class="row top_section_row mt-4" v-show="!showLoader">
          <div class="col-md-8">
            <span class="sec_text_color">
              {{ $t("text.manageExpenses.companyExpensesBetween") }}
              {{ $d(new Date(startDate), "short", this.$root.$i18n.locale) }}
              {{ $t("text.and.text") }}
              {{ $d(new Date(endDate), "short", this.$root.$i18n.locale) }}
            </span>
            <span></span>
          </div>
          <div class="col-md-4 text-right">
            <!-- <button class="show_more_button remove_text_decoration"  @click="downloadWithCSS">
              Download Sales Report
            </button>-->
          </div>
        </div>
        <div class="row add_driver_row record__expenses">
          <div class="col-md-3 mt-1 remove_right_left_padding">
            <div class="recently_updated_wrapper" style="height: 84px">
              <div class="recently_updated">
                <h4 class="recently_updated_text mt-3">
                  <img
                    src="@/assets/img/transaction.svg"
                    width="20px"
                    class="mr-2"
                  />{{ $t("text.manageExpenses.expensesBreakdown") }}
                </h4>
              </div>
            </div>
            <div class="card_block mt-1">
              <div class="card_item">
                <h3 class="card__header green_text">
                  {{ $t("text.manageExpenses.income") }}
                </h3>
              </div>
              <div class="card_item mt-3">
                <div class="card_icon_div green">
                  <img src="@/assets/img/ss.svg" width="35px" />
                </div>
              </div>
              <div class="card_item mt-3">
                <!-- <h3 class="card__header green_text">&#8358; {{totalIncome}}</h3> -->
                <h3 class="card__header green_text">
                  {{ company ? company.currencyCode : "" }}
                  {{ decimalThousand(totalIncome) }}
                  <!-- {{ $n(totalIncome, "currency") }} -->
                </h3>
              </div>
            </div>
            <div class="card_block mt-1">
              <div class="card_item">
                <h3 class="card__header red_text">
                  {{ $t("text.manageExpenses.expenses") }}
                </h3>
              </div>
              <div class="card_item mt-3">
                <div class="card_icon_div red">
                  <img src="@/assets/img/Page-1 (1).svg" width="35px" />
                </div>
              </div>
              <div class="card_item mt-3">
                <!-- <h3 class="card__header red_text"> &#8358; {{totalExpenses}}</h3> -->
                <h3 class="card__header red_text">
                  {{ company ? company.currencyCode : "" }}
                  {{ decimalThousand(totalExpenses) }}
                  <!-- {{ $n(totalExpenses, "currency") }} -->
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-9 mt-3">
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="50" field="index" headerText="#"></e-column>
                <e-column
                  width="200"
                  field="branchName"
                  :headerText="$t('text.manageExpenses.retailOutlets')"
                ></e-column>
                <e-column
                  width="200"
                  field="amount"
                  format="N2"
                  :headerText="$t('text.manageExpenses.amount')"
                ></e-column>
                <e-column
                  width="200"
                  field="account"
                  :headerText="$t('text.manageExpenses.account')"
                ></e-column>
              </e-columns>
            </ejs-grid>
            <TableLoader :showLoader="showLoader" />
          </div>
        </div>
      </section>
      <EditCategoryModal
        :id="categoryId"
        :categoryName="categoryName"
      ></EditCategoryModal>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import EditCategoryModal from "@/components/modals/Manage_Expenses/editCategory.vue";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Manage Expenses :: Epump Portal",
  name: "ManageExpenses",
  components: {
    MasterLayout,
    EditCategoryModal,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      category: "",
      totalExpenses: 0,
      totalIncome: 0,
      expensesCount: 0,
      categoryCount: 0,
      company: null,
      backgroundUrl,
      categoryId: null,
      categoryName: "",
      showLoader: false,

      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },

      transFilter: "Show All",
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pluginStartDate: this.$moment().subtract(7, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getExpenses();
      }
    },
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getExpenses();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getExpenses();
    }
    this.dateRange.start = this.pluginStartDate;
    this.dateRange.end = this.pluginEndDate;
  },

  mounted() {
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    decimalThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getExpenses() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Expenses/Company/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.totalExpenses = response.data.totalExpenses;
          this.totalIncome = response.data.totalIncome;
          this.expensesCount = response.data.companyExpenses.length;
          response.data.companyExpenses.sort((a, b) => {
            return a.branchName > b.branchName ? 1 : -1;
          });
          response.data.companyExpenses.forEach((exp, index) => {
            exp.index = index + 1;
            exp.text = [
              this.$t("text.manageExpenses.confirmDelete"),
              this.$t("text.manageExpenses.successfullyDeleted"),
              this.$t("text.manageExpenses.unsuccessfulDelete"),
            ];
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data.companyExpenses,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
@media screen and (max-width: 602px) {
  .editCategoryModal .v--modal-box.v--modal {
    width: 90% !important;
    left: 0 !important;
    margin: 0 auto !important;
    height: 392px !important;
  }
}
</style>
